import pinia from "@/plugins/pinia";
import { useMenuStateStore } from "@/store/menu-state";
import { useRequestDataStore } from "@/store/request-data";
import { BaseMenuEntry } from "./base-menu-entry";

export class CovariatesMenuEntry extends BaseMenuEntry
{
    protected menuStateStore = useMenuStateStore(pinia);
    protected requestDataStore = useRequestDataStore(pinia);

    public getPicto() : string
    {
        return require("@/assets/pictos/menu-entries/04-covariates.svg");
    }

    public isEnabled() : boolean
    {
        return this.requestDataStore.isDrugModelSelected;
    }

    public isValid() : boolean
    {
        // Always valid because covariates are populated with default values
        return true;
    }

    public isValidated() : boolean
    {
        // Validated by user
        return this.menuStateStore.covariatesValidated;
    }

    public toggleValidation() : void
    {
        this.menuStateStore.covariatesValidated = !this.menuStateStore.covariatesValidated;
    }
}
